import { styled, TextV2 } from '@withjoy/joykit';

export const StyledTitle = styled(TextV2)`
  text-align: center;
`;
export const StyledSubtitle = styled(TextV2)`
  text-align: center;
`;
